export const ROUTES = {
  FORM: 'review_form',
  PAGES: {
    ALL: 'reviews',
    LANDING: 'landing_reviews',
    MERCHANT: 'merchant_reviews',
  },
}
